module.exports = __webpack_public_path__ + "static/img/goodness4.05d3dc86.png";